<template>
    <div class="reglement-components">
        <h1>Règlement</h1>
        <div class="reglement-container">
            <div class="reglement-container-checkbox">
                <label><input type="radio" name="name" value="" /> Tous P.S.</label>
                <label><input type="radio" name="name" value="" /> Inclure les retours déjà traités</label>
            </div>
            <div class="reglement-container-input">
                <label>du <input type="text" name="name" value="" /></label>
                <label>au <input type="text" name="name" value="" /></label>
            </div>
        </div>
        <div class="reglement-container-choix">
            <button class="choix1">Imprimer la liste</button>
            <button class="choix2">Total des retours sélectionnés :</button>
        </div>
        <div>
            <table class="table-container">
                <tr>
                    <th>Date retour</th>
                    <th>Emis le</th>
                    <th>N° RSP</th>
                    <th>Réglé</th>
                    <th>Attendu</th>
                    <th>Hors FSE</th>
                    <th>Différence</th>
                    <th>Organisme</th>
                    <th>Libellé</th>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </tr>
            </table>
        </div>
        <div class="reglement-container-button">
            <button>Imprimer la liste</button>
            <button>Exporter la sélection </button>
            <button>Marquer traités</button>
            <button>Marquer traitée la sélection</button>
        </div>
    </div>
</template>

<style scoped>
    
    .reglement-container-input input {
        width: 200px;
        height: 30px;
        border: none;
        margin-left: 5px;
    }
    .reglement-container {
        width:98%;
        padding:5px;
        margin-left:10px;
        background-color: #88B3ED;
    }

    .reglement-container-checkbox input {
        width: 50px;
        background-color: #88B3ED;
    }
    .reglement-components {
        background-color: #004AAD;
    }

    h1, label, th, td, button {
        color: white;
        margin: 5px;
    }

    h1 {
        text-align: center;
        padding: 10px;
    }

    .table-container {
        width: 100%;
        overflow-x: auto;
    }

    table {
        width: 100%;
        border-collapse: collapse;
    }

    th {
        background: #0553BB;
        color: white;
        padding: 10px;
    }

    td {
        padding: 10px;
    }
    .reglement-container {
        display: flex;
        flex-direction: row;
        align-items:center;
    }
    .reglement-container-checkbox {
        display: flex;
        flex-direction: column;
    }
    input{
        border:none;
    }
    .reglement-container-input {
        display: flex;
        flex-direction: row;
        margin-left:60px;
    }
    .reglement-components {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #3D7ED6;
        border-radius: 10px;
        width: 950px;
        height: 600px;
    }
    .choix1 {
        background: #004AAD;
        color: white;
        border: none;
        padding: 5px;
    }
    .choix2 {
        background: #88B3ED;
        color: white;
        border: none;
        padding: 5px;
        width: 500px;
        text-align:start;
    }
    .reglement-container-button{
        margin-top:280px;
        margin-left:170px;
    }
    .reglement-container-button button {
        background: #004AAD;
        color: white;
        border: none;
        border-radius: 10px;
        padding: 5px;
    }
</style>